// src/components/comments/CommentForm.js
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../utils/api';
import '../../styles/comments.css';

const CommentForm = ({ postId, onCommentAdded }) => {
  const { user } = useAuth();
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!text.trim()) {
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await api.post(`/api/comments/post/${postId}`, { text });
      
      setText('');
      
      if (onCommentAdded) {
        onCommentAdded(response.data.comment);
      }
    } catch (error) {
      console.error('Error adding comment:', error);
    } finally {
      setLoading(false);
    }
  };

  const getIMGURL = (url) => {
    if (!url) return '/default-avatar.png';
    
    if (url.startsWith('ipfs://')) {
      // Extract the CID (Content ID) from the IPFS URL
      const cid = url.replace('ipfs://', '');
      // Use a public IPFS gateway
      return `https://ipfs.io/ipfs/${cid}`;
    }
    
    return url;
  }
  
  return (
    <form className="comment-form" onSubmit={handleSubmit}>
      <div className="comment-form-avatar">
        <img 
          src={getIMGURL(user?.profilePic) || '/default-avatar.png'} 
          alt={user?.username} 
        />
      </div>
      
      <div className="comment-form-input">
        <input
          type="text"
          placeholder="Write a comment..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          disabled={loading}
        />
        
        <button 
          type="submit" 
          className="comment-submit"
          disabled={loading || !text.trim()}
        >
          {loading ? '...' : 'Post'}
        </button>
      </div>
    </form>
  );
};

export default CommentForm;